var _SovosNoDataIllustrat, _SovosNoSearchResults;
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { string, element, oneOf } from 'prop-types';
import { styled } from '@mui/material/styles';
import SovosTypography from '../../../sovos-typography';
import SovosNoDataIllustration from '../../../sovos-no-data-illustration';
import SovosNoSearchResultsIllustration from '../../../sovos-no-search-results-illustration';
import statusTypes from './statusTypes';
import useMosaicTranslation from '../../i18n/useMosaicTranslation';
const Root = styled('div')(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: spacing(40),
    paddingTop: spacing(4)
  };
});
const Content = styled('div')(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '50%',
    maxWidth: 500,
    '& button': {
      marginBlockStart: spacing(1.5)
    }
  };
});
const StyledTypography = styled(SovosTypography)(_ref3 => {
  let {
    theme: {
      spacing
    }
  } = _ref3;
  return {
    marginBlockStart: spacing()
  };
});
const NoResults = props => {
  const {
    t
  } = useMosaicTranslation();
  const defaultMessages = {
    noResults: {
      headingLabel: t('noResults'),
      helpLabel: t('noResultsLabels.helpLabel')
    },
    noData: {
      headingLabel: t('noResultsLabels.headingLabelData'),
      helpLabel: t('noResultsLabels.helpLabelData')
    }
  };
  const {
    variant = statusTypes.NO_RESULTS,
    actionButton
  } = props;
  const getLabel = type => {
    const {
      [type]: label
    } = props;
    if (label) {
      return label;
    }
    if (variant === statusTypes.NO_DATA) {
      return defaultMessages.noData[type];
    }
    return defaultMessages.noResults[type];
  };
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Content, null, variant === statusTypes.NO_DATA ? _SovosNoDataIllustrat || (_SovosNoDataIllustrat = /*#__PURE__*/React.createElement(SovosNoDataIllustration, null)) : _SovosNoSearchResults || (_SovosNoSearchResults = /*#__PURE__*/React.createElement(SovosNoSearchResultsIllustration, null)), /*#__PURE__*/React.createElement(SovosTypography, {
    variant: "h4",
    sx: {
      mt: 3
    }
  }, getLabel('headingLabel')), /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "body1"
  }, getLabel('helpLabel')), actionButton));
};
NoResults.propTypes = {
  variant: oneOf([statusTypes.NO_DATA, statusTypes.NO_RESULTS]),
  headingLabel: string,
  helpLabel: string,
  actionButton: element
};
export default NoResults;